import { useSnackbar } from 'notistack'
import { coursePatchService } from 'src/api/course'
import { patchCourseCollectionService } from 'src/api/collection'
import { PatchContent, PatchData } from 'src/model/patch'
import useQueuedSave from './useQueuedSave'

const BOTTOM_LEFT = { vertical: 'bottom', horizontal: 'left' }

const patchHidden =(service, id, hidden) => {
  const patch = new PatchData(null, id)
  patch.addContent(
    new PatchContent(hidden, 'hiddenFromCatalog', PatchData.OPERATION_REPLACE),
  )
  return service(patch)
}

/**
 * "Show in portal catalog" for a course or a learning path (Share › Links):
 * saved right away as `hiddenFromCatalog`. Hidden items still open from their
 * links; only the portal catalog leaves them out.
 *
 * @param {'course' | 'path'} kind
 * @param {{ id, hiddenFromCatalog?: boolean }} entity
 * @returns {[boolean, (listed: boolean) => void]}
 */
const useCatalogListing = (kind, entity) => {
  const { enqueueSnackbar } = useSnackbar()
  const service =
    kind === 'course' ? coursePatchService : patchCourseCollectionService

  return useQueuedSave(!entity?.hiddenFromCatalog, async listed => {
    try {
      await patchHidden(service, entity.id, !listed)
      // The store keeps this object, so the tab shows the saved value when
      // reopened before the next fetch.
      entity.hiddenFromCatalog = !listed
    } catch (error) {
      enqueueSnackbar("Couldn't save the catalog setting.", {
        variant: 'error',
        anchorOrigin: BOTTOM_LEFT,
      })
      throw error
    }
    enqueueSnackbar('Saved successfully', {
      variant: 'success',
      anchorOrigin: BOTTOM_LEFT,
    })
  })
}

export default useCatalogListing
